import * as React from 'react';
import { connect } from 'react-redux';
import './ClaimInfo.css';
import { showEstimatedTime, showFnolCallMeModal } from '../../../actions/modalActions';
import { Card } from 'react-bootstrap';
import { Image } from "react-bootstrap";
import { isMobile } from 'react-device-detect';
import { setIsMobileInfo } from '../../../actions/claimHistoryActionsV2';
import NeedHelp from '../../../../src/components/BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';

class ClaimInfo extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            carGlass: "inactive"
        };
        this.handleCallMeBack = this.handleCallMeBack.bind(this);
        this.handleShowEstimate = this.handleShowEstimate.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.getClaimStatusClass = this.getClaimStatusClass.bind(this);
        this.getClaimStatusMessage = this.getClaimStatusMessage.bind(this);
        this.getClaimStatus = this.getClaimStatus.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    async handleShowEstimate() {
        this.props.handleShowEstimatedTime();
    }

    async handleToggle() {
        this.setState({ carGlass: "active" });
    }

    getClaimStatusClass() {
        let cssClass = '';
        switch (this.props.claimSubmit.selectedClaim.claimStatusCategory) {
            case 'Approved': cssClass = 'Approved'; break;
            case 'Pending': cssClass = 'Pending'; break;
            case 'Cancelled': cssClass = 'Cancelled'; break;
            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    getClaimStatusMessage() {
        let message : any = null;
        switch (this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase()) {
            case 'claim closed': {
                message = <>
                    Thanks for letting us know that you don’t want to proceed with this claim. We’ve cancelled it on our side. We’ve noted this as an incident on your profile, so that we have a complete history for you.
                </>
                break;
            }
            case 'claim not approved':
            case 'claim not authorised': {
                message = <>
                    Unfortunately, this claim isn’t valid. We’ve sent you a detailed explanation via email, so please check your inbox.
                </>
                break;
            }
            case 'claim cancelled (internal kp error)': {
                message = <>
                    Claim cancelled due to an internal error.
                    <br /><br/>
                    Look out for a new claim for this incident in your list of claims. If you don’t see your new claim, request a call back.
                </>
                break;
            }
        }
        return message;
    }

    getClaimStatus(claimStepDescription: String) {
        return this.props.claimSubmit.claimProgress.claimSteps.filter(x => (x.isComplete || x.stepEstProgressBar == 100) && x.claimStepDescription.toLowerCase() == claimStepDescription.toLowerCase()).length > 0 ? true : false;
    }

    async handleBackClick() {
        this.props.handleSetIsMobileInfo(false);
    }

    public render() {
        let isIncidentDate = this.props.claimSubmit.selectedClaim.incidentDate;
        let isRegisteredDate = this.props.claimSubmit.selectedClaim.claimRegisteredDate;

        let claimStatusClass = this.getClaimStatusClass();
        let claimStatusMessage = this.getClaimStatusMessage();
        let claimError = (this.props.claimSubmit.selectedClaim.claimStatusCategory === 'Cancelled' && this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase() === 'claim cancelled (internal kp error)');

        return (
            <>
                <div>
                    {isMobile &&
                        <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                    }
                    <Card className="content-box-padding-20px-with-box-shadow" id="basic-temp">
                        <div className="row noma">
                            <div className="col-12 nopa">
                                <p className="claim-title mb-10px">{this.props.claimSubmit.selectedClaim.riskItemType}: {this.props.claimSubmit.selectedClaim.incident}</p>
                                <p className="description mb-10px">{this.props.claimSubmit.selectedClaim.riskItem}</p>
                                <p className="mb-0px">Claim no. <b>{this.props.claimSubmit.selectedClaim.claimNumber}</b></p>
                                <hr className="mt-14px mb-15px claims-v2-hr-2px" />
                                {isIncidentDate && <div className="row noma mb-10px">
                                    <div className="col nopa">
                                        <p className="mb-0px"><b>Incident date and time</b></p>
                                    </div>
                                    <div className="col nopa">
                                        <p className="noma text-right">{this.props.claimSubmit.selectedClaim.incidentDate}</p>
                                    </div>
                                </div>}
                                {isRegisteredDate && <div className="row noma">
                                    <div className="col nopa">
                                        <p className="mb-0px"><b>Claim logged</b></p>
                                    </div>
                                    <div className="col nopa ">
                                        <p className="mb-0px text-right">{this.props.claimSubmit.selectedClaim.claimRegisteredDate}</p>
                                    </div>
                                </div>}
                                {isIncidentDate && isRegisteredDate && <hr className="mt-15px mb-15px claims-v2-hr-2px" />}
                                <div className="row noma d-none">
                                    <div className="col-12 col-md col-lg nopa">
                                        {this.props.profile.selectedPersonalClaimStep && this.props.profile.selectedPersonalClaimStep.toLowerCase() === "overview" &&
                                            <p className="mb-0px"><b>Overall estimated completion date</b>
                                                <span className="ml-lg-3 ml-1"><Image onClick={() => this.handleShowEstimate()} className="completionTooltip cursor" id="completionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="raftool" data-tip="" /></span>
                                            </p>
                                        }
                                        {this.props.profile.selectedPersonalClaimStep && (this.props.profile.selectedPersonalClaimStep.toLowerCase() !== "overview") &&
                                            <p className="mb-0px"><b>Estimated completion date for this step</b>
                                                <span className="ml-lg-3 ml-1"><Image onClick={() => this.handleShowEstimate()} className="completionTooltip cursor" id="completionTooltip" alt="" src="./images/icons-line-style-info-32-px.svg" data-for="raftool" data-tip="" /></span>
                                            </p>
                                        }
                                    </div>
                                    <div className="col-12 col-md col-lg text-lg-right nopa">
                                        <p className={((this.props.profile.selectedPersonalClaimStep.toLowerCase() !== "overview") ? "text-red " : "") + "ma-bottom-5px"}>30 April</p>
                                        <p className="Or-latest">Or latest 10 June</p>
                                    </div>
                                </div>
                                <hr className="mt-15px mb-15px claims-v2-hr-2px d-none" />
                                <div className="row noma">
                                    <div className="col-12 nopa">
                                        <span className={'dot float-left ' + claimStatusClass}></span>
                                        <p className={claimStatusClass.toLowerCase() + '-text status-text'}>
                                            Status: {this.props.claimSubmit.selectedClaim.claimStatus}
                                        </p>
                                    </div>
                                    {claimStatusClass === "Cancelled" &&
                                        <div className="col-12 nopa">
                                            <p className="float-left mt-20px mr-10px mb-5px">
                                                {claimStatusMessage}
                                            </p>
                                        </div>
                                    }
                                </div>
                                {claimError === false &&
                                <>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    <div className="row noma">
                                        <div className="col-12 col-md col-lg nopa">
                                            <p className="text-16 mb-0px"><b>Claims consultant</b></p>
                                        </div>
                                        <div className="col-12 col-md col-lg nopa mobile-mt-10px">
                                            <p className="text-lg-right mb-0px">{this.props.claimSubmit.selectedClaim.claimAdmin}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    <div className="row noma">
                                        <div className="col-12 col-md col-lg nopa">
                                            <p className="text-16 mb-0px"><b>Type of claim</b></p>
                                        </div>
                                        <div className="col-12 col-md col-lg nopa mobile-mt-10px">
                                            <p className="text-lg-right mb-0px">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.incidentType}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    <div className="row noma">
                                        <div className="col-12 col-md col-lg nopa">
                                            <p className="text-16 mb-0px"><b>Cause of damage</b></p>
                                        </div>
                                        <div className="col-12 col-md col-lg nopa mobile-mt-10px">
                                            <p className="text-lg-right mb-0px">{this.props.profile.selectedPersonalClaim !== "" && this.props.profile.selectedPersonalClaim.incident}</p>
                                        </div>
                                    </div>
                                    <hr className="mt-15px mb-15px claims-v2-hr-2px" />
                                    <div className="row noma">
                                        <div className="col-12 col-md col-lg nopa">
                                            <p className="text-16 mb-0px"><b>Your total excess payment will be</b></p>
                                        </div>
                                        <div className="col-12 col-md col-lg nopa mobile-mt-10px">
                                            <p className="text-lg-right total-excess text-red mb-0px"><b>{this.props.profile.selectedPersonalClaim && ((this.props.profile.selectedPersonalClaim.claimStatus === "Unknown" && this.props.profile.selectedPersonalClaim.totalExcess === 0) ? "TBD" : this.props.profile.currencySymbol + " " + this.props.profile.selectedPersonalClaim.totalExcess)}</b></p>
                                        </div>
                                    </div>
                                </>
                                }
                                {claimError === false && this.state.carGlass === "active" && <hr className="mt-15px mb-15px claims-v2-hr-2px" />}
                                {claimError === false && this.state.carGlass === "active" &&
                                    <div className="row noma">
                                        <div className="col-lg-6 col-12 nopa">
                                            <p className="text-16 mb-0"><b>Repair centre</b></p>
                                        </div>
                                        <div className="col-lg-6 col-12 nopa text-lg-right">
                                            <p className="text-red">Autoboys Lynnwood</p>
                                            <p className="font-weight-500">Corobay Drive,<br />
                                                Pretoria<br /> 012 942 9385<br />
                                                    <a className="aTagColor" href="mailto:info@autoboys.co.za" target="_blank"><span className="text-decoration-underline">info@autoboys.co.za</span></a>
                                                </p>
                                                <button className="btn btn-solid-green font-size-12px pull-lg-right button-width-height">Get directions</button>
                                            </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </Card>
                </div>
                <div className="d-none"> {/*{hidden for now untill we have a generic block}*/}
                    <div id="needHelp" className="mt-10px">
                        <NeedHelp
                            isClaims={true}
                            countryId={this.props.profile.countryId}
                            claimsEmail={this.props.ssp.claims_email}
                            contactUsTel={this.props.ssp.contactUs_tel}
                            handleCallMeBack={(e) => this.handleCallMeBack(e)}
                        />
                    </div >
                </div >
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
        ssp: state.ssp
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showFnolCallMeModal()),
        handleShowEstimatedTime: () => dispatch(showEstimatedTime()),
        handleSetIsMobileInfo: (flag) => dispatch(setIsMobileInfo(flag))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ClaimInfo);